import { apiFetch } from './httpClient';
import { CommandeGroupee } from './CommandeFournisseurService';

export type CommandeFournisseurStatut = 'BROUILLON' | 'ENVOYEE' | 'RECUE' | 'ANNULEE' | 'GENEREE';

export interface CommandeFournisseurRecord {
  id: string;
  numeroCommande: string;
  dateCreation?: string;
  devisInclus?: string[];
  totaux?: {
    montantMatieres: number;
    montantFournitures: number;
    montantTotal: number;
    nombreDevis: number;
  };
  statut: CommandeFournisseurStatut;
  payload?: any;
  total_ht?: number;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface ListerCommandesParams {
  statut?: string;
  q?: string;
  limit?: number;
  offset?: number;
  devisId?: string | number;
  devisRef?: string;
}

class CommandeFournisseurApiService {

  async creerCommande(payload: CommandeGroupee, statut?: CommandeFournisseurStatut): Promise<CommandeFournisseurRecord> {
    return apiFetch<CommandeFournisseurRecord>('/commandes-fournisseur', {
      method: 'POST',
      body: JSON.stringify({ payload, statut })
    });
  }

  async listerCommandes(params: ListerCommandesParams = {}): Promise<CommandeFournisseurRecord[]> {
    const query = new URLSearchParams();
    const { statut, q, devisId, devisRef, limit = 500, offset = 0 } = params;
    if (statut) query.set('statut', statut);
    if (q) query.set('q', q);
    if (devisId) query.set('devisId', String(devisId));
    if (devisRef) query.set('devisRef', devisRef);
    query.set('limit', limit.toString());
    query.set('offset', offset.toString());

    const suffix = query.toString() ? `?${query.toString()}` : '';
    return apiFetch<CommandeFournisseurRecord[]>(`/commandes-fournisseur${suffix}`);
  }

  async lireCommande(id: string): Promise<CommandeFournisseurRecord> {
    return apiFetch<CommandeFournisseurRecord>(`/commandes-fournisseur/${id}`);
  }

  async majStatut(id: string, statut: CommandeFournisseurStatut): Promise<CommandeFournisseurRecord> {
    return apiFetch<CommandeFournisseurRecord>(`/commandes-fournisseur/${id}/statut`, {
      method: 'PATCH',
      body: JSON.stringify({ statut })
    });
  }
}

export const commandeFournisseurApiService = new CommandeFournisseurApiService();
